/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rowPart{margin-left:0!important;margin-right:0!important;height:66px!important;line-height:66px!important}.parts-list{margin-bottom:10px}fieldset.parts-list-border{border:2px solid green!important;border-radius:10px!important;padding:5px!important;width:100%!important}legend.parts-list-border{width:auto!important;padding-left:10px!important;padding-right:10px!important;border:none!important;font-size:14px!important}"];
export { styles as styles };
